import * as React from 'react';
import { Container, Grid, IconButton, Button, Toolbar, Typography, ImageList } from '@mui/material';
import { useForm } from 'react-hook-form';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import moment from '../config/moment.config';
// import { TextsmsTwoTone } from '@mui/icons-material';

import { useNavigate, useParams } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Layout from './layout/layout';
import axios from '../AxiosInstance';
import useNotification from '../components/notification';
import UploadDropFile from '../components/dropzone';
import Gallery from '../components/Gallery';

const schema = yup.object().shape({
  firstname: yup.string().required(),
  lastname: yup.string().required(),
  email: yup.string().required(),
  phoneNumber: yup.string().required(),
});

export default function EditUser() {
  const history = useNavigate();
  const { sendNotification } = useNotification();
  // console.log(params)
  const formContext = useForm({
    resolver: yupResolver(schema),
  });
  const { id } = useParams();
  const [masterData, setMasterData] = React.useState(null);

  // fetch data from API function
  async function fetch() {
    const response = await axios.get(`/masters/${id}`);
    // console.log(response.data);
    response.data.created_date = moment(response.data.created_date).format('lll');
    response.data.updated_date = moment(response.data.updated_date).format('lll');
    setMasterData(response.data);
  }

  React.useEffect(() => {
    if (id !== 'add') {
      fetch();
    }
  }, []);
  React.useEffect(() => {
    formContext.reset(masterData);
  }, [masterData]);

  const handleSubmit = (data) => {
    console.log(data);

    const master = {
      firstname: data.firstname,
      lastname: data.lastname,
      email: data.email,
      phoneNumber: data.phoneNumber,
      note: data.note,
      status: data.status,
    };
    if (id === 'add') {
      axios
        .post('/masters/add', master)
        .then((res) => {
          sendNotification({ msg: 'Add new master success', variant: 'success' });
          history.goBack();
        })
        .catch((err) => {
          sendNotification({ msg: "can't save pls open console", variant: 'error' });
          console.error(err.response.data);
        });
    } else {
      axios
        .put(`/masters/${masterData.masterId}`, master)
        .then((res) => {
          sendNotification({ msg: 'Update master success', variant: 'success' });
          history.goBack();
        })
        .catch((err) => {
          sendNotification({ msg: "can't save pls open console", variant: 'error' });
          console.error(err.response.data);
        });
    }
  };

  return (
    <Layout>
      <FormContainer formContext={formContext} onSuccess={handleSubmit}>
        <Grid container item md={10} sm={12} xs={12}>
          <Toolbar sx={{ width: '100%' }}>
            <IconButton aria-label='expand row' size='small' onClick={() => history.goBack()} sx={{ marginRight: 2 }}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant='h6' noWrap component='div' sx={{ flex: 1 }}>
              {id === 'add' ? 'Add Master' : 'Edit Master'}
            </Typography>
            <Button size='small' type='submit'>
              Save
            </Button>
          </Toolbar>
        </Grid>

        <Container>
          <Grid container spacing={2} item md={10} sm={12} xs={12}>
            <Grid item md={6} sm={12} xs={12}>
              <TextFieldElement name='firstname' label='ชื่อ *' fullWidth size='small' />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <TextFieldElement name='lastname' label='นามสกุล *' fullWidth size='small' />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <TextFieldElement name='email' label='Email *' fullWidth size='small' />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <TextFieldElement name='phoneNumber' label='เบอร์โทร *' fullWidth size='small' />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <UploadDropFile width={70} />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <Gallery cols={4} />
            </Grid>
            {id === 'add' ? null : (
              <React.Fragment>
                <Grid item md={6} sm={12} xs={12}>
                  <TextFieldElement name='created_date' label='วันที่สร้าง' fullWidth size='small' disabled />
                </Grid>
                <Grid item md={6} sm={12} xs={12}>
                  <TextFieldElement name='updated_date' label='อัพเดทล่าสุด' fullWidth size='small' disabled />
                </Grid>
              </React.Fragment>
            )}
          </Grid>
        </Container>
      </FormContainer>
    </Layout>
  );
}
